export class TermsAgreed {

    userCode: string;
    userType: string;
    termsType: string;
    agreedOn: string;

}
